module.exports = __webpack_public_path__ + "static/img/logo.dd38088.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/logo.png
// module id = gKT4
// module chunks = 8